export const fields = [
  {
    fieldName: "Ποινικό Δίκαιο",
    fieldList: [
      "Εγκλήματα του ν. 4251/2014, διακίνησης μεταναστών, διευκόλυνση εισόδου των μεταναστών, Εγκλήματα κατά της Περιουσίας και Ιδιοκτησίας, Ναρκωτικά,  Εγκλήματα γενετήσιας ελευθερίας, Υπηρεσιακά εγκλήματα",
      "Παράσταση και εκπροσώπηση ενώπιον όλων των ποινικών δικαστηρίων για κακούργημα/πλημμέλημα",
      "Παράσταση σε ανακριτικές αρχές για κακούργημα/πλημμέλημα",
      "Σύνταξη/Κατάθεση Μήνυσης, Απολογητικού Υπομνήματος, Έφεσης, Αναίρεσης, Εισαγγελική Παραγγελία, Μετατροπή Ποινής σε Χρηματική, Δοσοποίηση, Κοινωφελής Εργασία",
    ],
    fieldId: 1,
    fieldRoute: "criminal-law",
    fieldTitle: "Τομείς Δικαίου | Ποινικό Δίκαιο",
    fieldDescription:
      "Νομικές υπηρεσίες για εγκλήματα όπως διακίνηση μεταναστών, περιουσιακά, ναρκωτικά, γενετήσιας ελευθερίας και υπηρεσιακά. Παράσταση σε δικαστήρια, ανακριτικές αρχές, σύνταξη νομικών εγγράφων και διαχείριση ποινών.",
  },
  {
    fieldName: "Αστικό Δίκαιο",
    fieldList: [
      "Αποζημίωση από αυτοκινητιστικά ατυχήματα",
      "Τραπεζικό Δίκαιο, Ανακοπές κατά κατάσχεσης, Ανακοπές κατά πλειστηριασμού,Αγωγές ακύρωσης δανειακών συμβάσεων, Διαδικασία Αναγκαστικής Εκτέλεσης, για είσπραξη απαιτήσεων.",
      "Εμπράγματο δίκαιο, αγοραπωλησίες ακίνητων, εγγραφή υποθήκης και προσημείωσης, αγωγές διεκδικητικές και νομής, Οικογενειακό Δίκαιο, Έκδοση διαζυγίου κατ’ αντιδικία, συναινετικά και ενώπιον του Μουφτή.",
      "Παράσταση ενώπιον όλων των πολιτικών δικαστηρίων (Πρωτοδικείο, Εφετείο και Άρειος Πάγος) για υποστήριξη ή απόκρουση αγωγής, ένδικων μεσών και βοηθημάτων.",
    ],
    fieldId: 2,
    fieldRoute: "civil-law",
    fieldTitle: "Τομείς Δικαίου | Αστικό Δίκαιο",
    fieldDescription:
      "Νομική υποστήριξη σε αυτοκινητιστικά ατυχήματα, τραπεζικό δίκαιο, ανακοπές και είσπραξη απαιτήσεων. Εμπράγματο δίκαιο, οικογενειακό δίκαιο, παράσταση σε πολιτικά δικαστήρια.",
  },
  {
    fieldName: "Δημόσιο Δίκαιο",
    fieldList: [
      "Πειθαρχικό δίκαιο των δημοτικών και υπάλληλων των ΟΤΑ, Πειθαρχικό δίκαιο ένστολου προσωπικού αστυνομίας, πυροσβεστικής και στρατού, Παράσταση σε πειθαρχικό συμβούλιο για απόκρουση της διαθεσιμότητας ή επιβολής αργίας.",
      "Προσφυγή κατά προστίμων από φορολογία, τελωνειακές παραβάσεις, εμπορίου, προσφυγή για συνταξιοδοτικά θέματα, ακύρωση αποφάσεων ΚΕΠΑ και δίκαιο κοινωνικής ασφάλισης.",
      "Εκπροσώπηση ΝΠΔΔ, ΟΤΑ, Δήμων, Δημοτικών Επιχειρήσεων παροχή γνωμοδότησης, δικαστική εκπροσώπηση, επικουρία σε πειθαρχικές διαδικασίες.",
      "Παράσταση ενώπιον όλων των διοικητικών δικαστηρίων (Διοικητικό Πρωτοδικείο, Διοικητικό Εφετείο, Συμβούλιο της Επικρατείας, Ελεγκτικό Συνέδριο για υποστήριξη ή απόκρουση ένδικων μέσων και βοηθημάτων.",
    ],
    fieldId: 3,
    fieldRoute: "public-law",
    fieldTitle: "Τομείς Δικαίου | Δημόσιο Δίκαιο",
    fieldDescription:
      "Υποστήριξη σε πειθαρχικό δίκαιο δημοτικών υπαλλήλων, ένστολων, προσφυγές σε φορολογικά/συνταξιοδοτικά θέματα, εκπροσώπηση ΝΠΔΔ/ΟΤΑ, παράσταση σε διοικητικά δικαστήρια.",
  },
  {
    fieldName: "Στρατιωτικό Δίκαιο",
    fieldList: [
      "Ζητήματα μεταθέσεων, αποσπάσεις, απαλλαγής ή αναβολής στρατιωτικής θητείας, ζητήματα εναλλακτικής θητείας, εξαγοράς θητείας.",
      "Παράσταση ως συνήγορος υπεράσπισης ενώπιον Στρατοδικείου, Ναυτοδικείου και Αεροδικείου.",
    ],
    fieldId: 4,
    fieldRoute: "military-law",
    fieldTitle: "Τομείς Δικαίου | Στρατιωτικό Δίκαιο",
    fieldDescription:
      "Υποστήριξη σε ζητήματα μεταθέσεων, αποσπάσεις, στρατιωτικής θητείας, και παράσταση σε στρατιωτικά δικαστήρια ως συνήγορος υπεράσπισης.",
  },
];

export const publications = [
  {
    pubName:
      "Οι έννομες συνέπειες άκυρων και ακυρώσιμων δικαιοπραξιών, σε: Figshare, Thesis.",
    pubLink: "https://doi.org/10.6084/m9.figshare.12061569.v1",
    pubDescription: [
      `Εκπονήθηκε στα πλαίσια Π.Μ.Σ Αστικού δικαίου και έχει ως αντικείμενο τις
έννομές συνέπιες των άκυρων και ακυρώσιμων δικαιοπραξιών όπως ρυθμίζονται από
τις διατάξεις 180-184 ΑΚ των Γενικών Αρχών του Αστικού Δικαίου. Στην μελέτη
παρουσιάζονται οι έννοιες των άκυρων και ακυρώσιμων δικαιοπραξιών με την
διάκριση τους σε κατηγορίες με τις πρόσφατες θέσεις της επιστήμης. Ενώ στην
συνέχεια η μελέτη επικεντρώνεται στον τρόπο της άσκησης της ακυρότητας και
ακυρωσίας και την παραγωγή των έννομων αποτελεσμάτων και τα ειδικότερα
ζητήματα που δημιουργούνται από τις έννομες συνέπειες των άκυρων και
ακυρώσιμων δικαιοπραξιών. Η μελέτη ολοκληρώνεται με την αναφορά στη θεωρία
των πολλαπλών ενεργειών, ήτοι στην συρροή των λόγων της ακυρότητας και
ακυρωσίας προκειμένου ο αναγνώστης να έχει μια πλήρη εικόνα των θεσμών της
δημόσιας τάξης και τυχόν την αντιμετώπιση της σύγκρουσης τους.`,
    ],
  },
  {
    pubName: `Ακυρότητα μεταβίβασης της οικογενειακής στέγης. Παρατηρήσεις στην απόφαση
ΜΠρΡοδόπ 15/2019, σε: Χρονικά Ιδιωτικού Δικαίου 2020, σ. 668-673`,
    pubLink: "#",
    pubDescription: [
      `Αφορά την κριτική σκέψη που ασκήθηκε στην υπ’ αριθμόν απόφαση ΜΠρΡοδόπ
15/2019 με αντικείμενο την ακυρότητα της δικαιοπραξίας λόγω αντίθεσης στα
χρηστά ήθη στην περίπτωση εκποίησης της οικογενειακής στέγης.`,
      `Παραπέμπεται από Ε. Κουνουγέρη-Μανωλεδάκη, Οικογενειακό Δίκαιο, 8 η εκδ. Τομ.
Ι, σ. 306-309, υποσημ. 83.`,
    ],
  },
  {
    pubName: `Επικοινωνία με τέκνα - Ακυρότητα δικαστικού συμβιβασμού. Παρατηρήσεις στην
απόφαση ΠΠρΑθ 1990/2017, σε: Εφαρμογές Αστικού Δικαίου και Πολιτικής
Δικονομίας 2020, σ. 359-361.`,
    pubLink: "#",
    pubDescription: [
      `Αφορά παρατηρήσεις σε απόφαση που αναγνωρίζει ακυρότητα του δικαστικού
συμβιβασμού λόγω έλλειψης της εξουσίας διάθεσης σε οικογενειακή διαφορά.`,
      `Παραπέμπεται από Κεραμεύς/Κονδύλης/Νίκας(-Κράνης), ΚπολΔ 2 υπο αρθ. 735, σ.
316·Βαλμαντώνης, Συνεπιμελεια και βέλτιστο συμφέρον του τέκνου σ. 106, υποσημ.
15·Ποδηματά, Ιδιωτική Διαμεσολάβηση κατά τον N 4640/2019, σ. 52, σημ.
193·Βαλμαντώνης σε ΔΕΑΚ Λεοντή, υπο αρθ. 1520, σ.3562.`,
    ],
  },
  {
    pubName: `Η συλλογική αγωγή για τις ζημίες στο δίκαιο του ανταγωνισμού, σε: Νομικό Βήμα,
2023 (υπό δημοσίευση)`,
    pubLink: "#",
    pubDescription: [],
  },
];
